import { Answer, Question, QuestionnaireService } from "@/types/questionnaire";
import BaseCard from "./BaseCard";
import QuestionRadio from "./QuestionRadio";
import QuestionCheckbox from "./QuestionCheckbox";
import QuestionMultiple from "./QuestionMultiple";

interface Properties {
    context: Answer,
    question: Question|null,
    questionIndex: number,
    questionTotal: number,
    setQuestionCompleted: (isComplete: boolean) => void;
    themeName: string,
    themeIndex: number,
    themeTotalSelected: number
}

function QuestionWrapper(properties: Properties) {
    const {context, question, questionIndex, questionTotal} = {...properties}
    const CIRCLE_SEGMENTS: number = 264;
    const questionPercentage: number = CIRCLE_SEGMENTS - (((CIRCLE_SEGMENTS * 0.9) * ((questionIndex + 1) / Math.max(questionTotal, questionIndex + 1))));
    
    const subAnswers: Answer[] = question ? question.answers : [];
    const hasSubQuestions: boolean = question ? QuestionnaireService.QuestionHasSubQuestions(question) : false;

    // determine which subquestion component to use
    let questionComponent: JSX.Element = <></>;
    if( question === null ) {
        questionComponent = <>TODO: Implement this, Q=N</>
    } else if( hasSubQuestions ) {
        questionComponent = <QuestionMultiple parentAnswer={context} question={question} setQuestionCompleted={properties.setQuestionCompleted}/>
    } else if( question.type === "switch" ) {
        questionComponent = <QuestionRadio question={question} setQuestionCompleted={properties.setQuestionCompleted}/>
    } else {
        questionComponent = <QuestionCheckbox question={question} setQuestionCompleted={properties.setQuestionCompleted}/>
    }

    return (
        <>
        <div className="relative flex flex-col w-full gap-5">
            <div className="text-white flex-none h-fit w-full flex flex-col">
                <div className="flex">
                    <div className="flex-1">
                        <h5 className="font-normal">Onderwerp {properties.themeIndex}/{properties.themeTotalSelected}</h5>
                        <h4 className="text-white">
                            { properties.themeName } 
                        </h4>
                    </div>
                    <div className="flex-initial progress-circle">
                        <svg width="5em" height="5em" viewBox="0 0 100 100">
                            <circle cx="50%" cy="50%" r="42" shapeRendering="geometricPrecision" fill="none" stroke="#f1f1f1" strokeWidth="12"></circle>
                            <circle cx="50%" cy="50%" r="42" shapeRendering="geometricPrecision" fill="none" strokeWidth="12" strokeDashoffset={ questionPercentage } strokeDasharray={ CIRCLE_SEGMENTS } strokeLinecap="butt" style={{transition: "stroke-dashoffset: 0.4s", transform: "rotate(-90deg)", transformOrigin: "50% 50%", stroke: "var(--color-secondary)"}}></circle>
                        </svg>
                        <span className="progress-text">
                        { properties.questionIndex + 1 } van { properties.questionTotal }
                        </span>
                    </div>
                </div>
            </div>
            <BaseCard>{ questionComponent }</BaseCard>
        </div>
        </>
    )
}

export default QuestionWrapper;